import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchIANoResultComponent',
  setup(__props) {

const { t } = useI18n()
const TEXT = {
  noResults: t('components.search_advance_ia.no_results_message'),
  suggestionsTitle: t('components.search_advance_ia.suggestions_title'),
  suggestion1: t('components.search_advance_ia.suggestion_1'),
  suggestion2: t('components.search_advance_ia.suggestion_2'),
  suggestion3: t('components.search_advance_ia.suggestion_3')
}

return { __sfc: true,t, TEXT }
}

})